import { UPDATE_SHARED_INTEGRATION } from "redux/constants/portal";
import {
  OPEN_NEW_INTEGRATION_DIALOG,
  CLOSE_NEW_INTEGRATION_DIALOG,
  SET_INTEGRATION_MUTATING_FLAG,
  CREATE_NEW_INTEGRATION,
  SET_INTEGRATIONS,
  ADD_INTEGRATION,
  REMOVE_DELETED_INTEGRATION,
  UPDATE_UPDATED_INTEGRATION,
  SET_OPEN_SHARE_INTEGRATION_DIALOG,
  SET_OPEN_UNSHARE_INTEGRATION_DIALOG,
  SET_OPEN_SHARE_UNSHARE_DIALOG,
  SET_OWNED_SHARED_INTEGRATIONS,
  SET_SHARED_INTEGRATIONS_SHARED,
  SET_SHARED_INTEGRATIONS,
} from "redux/constants/portal";

const initialState = {
  integrations: [],
  showNewIntegrationDialog: false,
  integrationMutatingFlag: false,
  openShareIntegrationDialog: false,
  openUnshareIntegrationDialog: false,
  openShareUnshareDialog: false,
  ownedSharedIntegrations: [],
  sharedIntegrationsShared: [],
  sharedIntegrations: [],
};

const view = (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_NEW_INTEGRATION_DIALOG:
      return {
        ...state,
        showNewIntegrationDialog: true,
      };
    case CLOSE_NEW_INTEGRATION_DIALOG:
      return {
        ...state,
        showNewIntegrationDialog: false,
      };
    case SET_INTEGRATION_MUTATING_FLAG:
      return {
        ...state,
        integrationMutatingFlag: payload,
      };
    case CREATE_NEW_INTEGRATION:
      return {
        ...state,
        integrationMutatingFlag: payload,
      };
    case SET_INTEGRATIONS:
      return {
        ...state,
        integrations: payload,
      };
    case ADD_INTEGRATION:
      if (!payload) return state;

      return {
        ...state,
        integrations: [...state.integrations, payload],
      };
    case REMOVE_DELETED_INTEGRATION:
      if (!payload) return state;

      return {
        ...state,
        integrations: state.integrations.filter((integration) => integration.id !== payload.id),
      };
    case UPDATE_UPDATED_INTEGRATION:
      if (!payload) return state;

      return {
        ...state,
        integrations: state.integrations.map((integration) =>
          integration.id === payload.id
            ? {
                ...integration,
                ...payload,
              }
            : integration
        ),
      };
    case SET_OPEN_SHARE_INTEGRATION_DIALOG:
      return {
        ...state,
        openShareIntegrationDialog: payload,
      };
    case SET_OPEN_UNSHARE_INTEGRATION_DIALOG:
      return {
        ...state,
        openUnshareIntegrationDialog: payload,
      };
    case SET_OPEN_SHARE_UNSHARE_DIALOG:
      return {
        ...state,
        openShareUnshareDialog: payload,
      };
    case SET_OWNED_SHARED_INTEGRATIONS:
      return {
        ...state,
        ownedSharedIntegrations: payload,
      };
    case SET_SHARED_INTEGRATIONS_SHARED:
      return {
        ...state,
        sharedIntegrationsShared: payload,
      };
    case SET_SHARED_INTEGRATIONS:
      return {
        ...state,
        sharedIntegrations: payload,
      };
    case UPDATE_SHARED_INTEGRATION:
      return {
        ...state,
        sharedIntegrations: state.sharedIntegrations.map((sharedIntegration) =>
          sharedIntegration.id === payload.id
            ? {
                ...sharedIntegration,
                ...payload,
              }
            : sharedIntegration
        ),
      };
  }
  return state;
};

export default view;
